$(document).ready( function() {
    $('.product-accessories .accessory input[type=checkbox]').on('change', function() {
        const id = $(this).closest('.accessory').attr('data-id');
        const quantity = $('.product-accessories.summary .accessory[data-id="' + id + '"] .quantity-field .qty')
        const quantityVal = quantity.val();
        if( $(this).is(':checked') ) {
            quantity.val(parseInt(quantityVal) + 1)
        } else {
            quantity.val(0)
        }

        quantity.trigger('change')
    })

    $('.product-accessories.summary .accessory input[type=number]').on('change', function() {
        const id = $(this).closest('.accessory').attr('data-id');
        const accessoryCheckbox = $('.product-accessories:not(.summary) .accessory[data-id="' + id + '"] input[type=checkbox]')
        const quantityVal = $(this).val()
        if( quantityVal > 0 ) {
            accessoryCheckbox.attr('checked', 'checked')
        } else {
            accessoryCheckbox.attr('checked', false)
        }
    })
})